import React from 'react'

function ProcessSystemDevelopment() {
  return (
    <div className="w-full py-5 bg-white mx-4 md:mx-10 lg:mx-20">
    <div className="w-full md:w-4/5 text-left md:pl-8">
      <h2 className="text-2xl font-semibold mb-6">
        PROCESS & SYSTEM DEVELOPMENT
      </h2>
      <p className="mb-4">
        "We specialize in professional training, focusing on crucial areas
        within construction and project management. Our offerings encompass
        corporate training and Continuous Professional Development (CPD)
        programs in the following key areas:
      </p>
      <p className="mb-4">
        Our consultancy offerings extend to the development of Enterprise
        Resource Planning (ERP) systems, incorporating the integration of
        associated processes and systems within the organization.
      </p>
      <p className="mb-4">
        Moreover, we conduct comprehensive reviews of internal processes,
        identifying areas for improvement and suggesting alterations to
        enhance overall efficiency and foster seamless integration among
        interconnected processes."
      </p>
    </div>
  </div>  
  )
}

export default ProcessSystemDevelopment